'use client';

import { FC } from 'react';
import { FormattedVariant } from '@/app/[locale]/product/[metaUrl]/get-variants';
import { Card, CardBody, CardFooter, Image, NavigateButton } from '@/components/ui';
import useNavigate from '@/hooks/use-navigate';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { cn } from '@/utils';

type Props = {
  item: FormattedVariant;
  index: number;
};

const VariantCard: FC<Props> = ({ item, index }) => {
  const navigate = useNavigate();
  const { isStudioPreview } = useAppContext<{ isStudioPreview?: boolean }>();
  const href = `/product/${item.values[index].metaUrl}`;

  if (item.selectType === 'IMAGE_TEXT')
    return (
      <Card
        shadow="sm"
        isPressable={!isStudioPreview}
        className={cn(
          'w-fit p-1 duration-75 ease-in-out hover:scale-105 hover:shadow-lg',
          item.values[index].isActive && 'border-primary bg-primary text-white',
        )}
        onPress={() => {
          if (isStudioPreview) return;
          navigate(href);
        }}
        onMouseEnter={() => {
          if (isStudioPreview) return;
          navigate.prefetch(href);
        }}
      >
        <CardBody className="p-1">
          <Image
            radius="md"
            width={55}
            height={55}
            alt={item.values[index].name}
            src={item.values[index].image}
          />
        </CardBody>
        <CardFooter className="text-tiny justify-center p-1">{item.values[index].value}</CardFooter>
      </Card>
    );
  if (item.selectType === 'TEXT')
    return (
      <NavigateButton
        href={href}
        variant="bordered"
        radius="full"
        isDisabled={isStudioPreview}
        className={cn(item.values[index].isActive && 'border-primary bg-primary text-white')}
      >
        {item.values[index].value}
      </NavigateButton>
    );
};

export default VariantCard;
